export const medievalSlides = [
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Wappenrock_kurz_repugn',
      title: 'Ein Kurzer Wappenrock',
      description: 'Ein kurz geschnittener Wappenrock aus Leinen.'
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Zeltreparatur_rstocn',
      title: 'Zeltreperatur',
      description: 'Reperatur des von mir genähten, in die Jahre gekommenen Tarp - viele Quadratmeter Stoff um mich rum. '
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Prunkgewandungen_mit_Nerz_ahoqjk',
      title: 'Prunkgewandung mit Nerz',
      description:'Von mir genähtes Edelgewand und passendes Höllenfesterkleid - Nachträglich mit Nerz verbrämt.'
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Lieblingsgugel_vbucdk',
      title:'Damengugel',
      description:'Damengugel aus geliefertem Stoff nach Wunsch. '
      },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Tom_Hansen_Häs_bvrc77',
      title: 'Häs',
      description: 'Ein Häs für einen guten Freund - nach eigenem Wunsch maßgeschneidert - das Hemd ist aus sehr altem Leinen, mit dem auch der Klappenrock aus grünem Loden gefüttert ist. Passende Mütze aus einer alten Pelzjacke. '
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Klappenrock_für_Baby_ono6wo',
      title:'Baby Klappenrock ',
      description:'Klappenrock für Baby, dass der Enkel meiner Freundin fürs Lager authentisch eingekleidet ist.'
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Pillbox_passend_zum_Kleid_js3qj2',
      title:'Pillbox',
      description:'Pillbox aus dem Reststoff vom Höllenfensterkleid. '
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/2_Schamkapsel-Hosen_ppiunq',
      title:'Schamkapselhosen',
      description:'2 Schamkapselhosen - nach Maß und Kundenwunsch. '
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Gewandung_für_Puppen_1_qdmgws',
      title:'Geburtstagsgeschenk',
      description:'Geburtstagsgeschenk für gute Freunde - aus Resten der von mir genähten Gewandung und selbst genähten Lederstiefel.'
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Gewandung_für_Puppe_2_c9a8qx',
      title:'Geburtstagsgeschenk',
      description:'Geburtstagsgeschenk nach einem Foto - komplett selbst gemacht - auch die Stiefel.'
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Gewandung_Puppen_3_lnyla6',
      title:'Hochzeitsgeschenk',
      description:'Hochzeitsgeschenk für meinen Sohn und seine Frau - aus Reststoffen der Gewandung.'
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Kleid_Mi-Parti_kvtrv9',
      title:'Mi-Parti Kleid',
      description:'Mi-Parti Kleid aus Diamantköper - komplett gefüttert. '
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Wams_Mi-Parti_nlzfsa',
      title:'Mi-Parti Wams',
      description:'Mi-Parti Wams - aus Wolle - komplett abgefüttert. '
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1758522371/om9fvwedjihwtqb6nqs8.jpg',
      title:'Tarp zuschneiden',
      description:''
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1758610446/kfijeurc2nigpsgi4xdd.jpg',
      title:'Tarp 1',
      description:''
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1758904027/lemwl9mstbuy5v5nccz1.jpg',
      title:'Tarp Zaddeln',
      description:''
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1759769511/jyfurshwhw8bsodaowoq.jpg',
      title:'Tarp Löcher',
      description:''
     },
      { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1760889936/o8mgya3mvmvxrfgjr2hk.jpg',
      title:'Stehendes Tarp',
      description:''
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1760030393/fm8k30ooyfriukd52vuw.jpg',
      title:'Vernähte Löcher des Tarps',
      description:''
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1760889941/gcobek76cwmjfpfoq3sg.jpg',
      title:'Tarp Innen',
      description:''
     },
     { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1760889954/wvsgqxwpytol9i6hj8qr.jpg',
      title:'Tarp Verpackt',
      description:''
     },
     
]

export const upcyclingSlides = [
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/maxi-cosy_-_Sack_rhfftp',
      title: '',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155316_eeecoa',
      title: '',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_154903_t3jor3',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155227_unbbc6',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155248_aeql6t',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155438_oti6pu',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155335_t3xle7',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155809_y7lm5t',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155507_dc17di',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155533_n2ubms',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Collage_2025-09-11_16_29_02_fa8wmj',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155911_nlyqgd',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/20250911_155941_dkhdzb',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Collage_2025-09-11_16_28_07_1_qs8tn8',
      title:'',
      description:''
    },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/Collage_2025-09-11_16_29_57_pbfe32',
      title:'',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1761120978/q0ibea3tylgwarpoedfy.jpg',
      title:'Katzenbett',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1762273276/xu6xwwqiw7tky3gmupp3.jpg',
      title:'Filzkäse',
      description:''
     },
    { src: 'https://res.cloudinary.com/dzlpy6osa/image/upload/v1762273282/q93xy9piirmywhafkfb8.jpg',
      title:'Filzkäse',
      description:''
     },
  ];


export const customSlides = [
  {src:'https://res.cloudinary.com/dzlpy6osa/image/upload/Brautpaar_dqthkg',
    title: 'Änderungen für das Brautpaar',
    description: 'Das Kleid musste um 6 Zentimeter weiter werden. Um den Stil zu erhalten, habe ich den seitlichen Reißverschluss nach hinten in die Mitte verlegt und aus dem Stoff, der rückwärtig übrig war, seitlich je 3 Zentimeter erfolgreich eingefügt. Beim Bräutigam waren die Hosen zu lang und das Hemd an der Schulter zu breit. Beides habe ich erfolgreich umgesetzt.'
  },
  {src:'https://res.cloudinary.com/dzlpy6osa/image/upload/v1761120985/xgrmmastuo57hqkzbfsg.jpg',
    title: 'Reißverschluss',
    description: 'Neuer Reißverschluss eingesetzt.'
  },
]